import React, { forwardRef, Ref, useImperativeHandle } from 'react';
import noop from 'lodash/noop';
import styles from './image-field.module.css';
import { useSignatureModalContext } from 'signer-app/signature-modal/signature-modal-context/context';
import { ImperativeAPI } from '../types/imperative-api';

type ImageProps = {
  alt?: string;
  id: string;
  isFormView?: boolean;
  'data-qa-ref'?: string;
  'data-testid'?: string;
};

function ImageFieldInternal(
  {
    isFormView,
    alt = '',
    id,
    'data-qa-ref': dataQaRef,
    'data-testid': dataTestId,
  }: ImageProps,
  ref: Ref<ImperativeAPI>,
) {
  const signatureProps = useSignatureModalContext();
  const src = signatureProps.getSignatureUrl({ guid: id });
  const className = isFormView ? styles.formViewImage : styles.image;

  useImperativeHandle(
    ref,
    () => ({
      focus: noop,
    }),
    [],
  );

  return (
    <div
      data-qa-ref={dataQaRef}
      data-testid={dataTestId}
      style={{
        height: '100%',
        width: '100%',
        cursor: 'auto',
        boxSizing: 'border-box',
      }}
    >
      <img alt={alt} className={className} src={src} />
    </div>
  );
}

export const ImageField = forwardRef(ImageFieldInternal);
